// extracted by mini-css-extract-plugin
export default {"CallbackURL":"akSfvABHgVQaW4jCjKGk","CopyButton":"mrJhUbtUFP5a0ZJ_U9IQ"};